module.exports = __webpack_public_path__ + "static/media/close.45259f5e.svg";